import { filesystemItemType } from '@/dataroom/domain/filesystem';

export const modalTitle = {
  [filesystemItemType.FOLDER]: 'Edit Folder',
  [filesystemItemType.FILE]: 'Edit File',
  [filesystemItemType.URL]: 'Edit Hyperlink',
};
